module.exports = __webpack_public_path__ + "static/media/clouds.8988c5e3.jpg";